export const AI_COURSE_IMAGES = {
  'ai-red-teaming-promptfoo-rag-chatbots-agents': '/images/courses/ai-red-teaming-promptfoo-rag-chatbots-agents.jpg',
  'zero-code-ai-testing': '/images/courses/zero-code-ai-testing.jpg',
  'genai-multi-agent-software-testing': '/images/courses/genai-multi-agent-software-testing.jpg',
  'ai-testing-deepeval-chatbot-rag-agent-mcp': '/images/courses/ai-testing-deepeval-chatbot-rag-agent-mcp.jpg',
  'ai-testing-deepeval-ragas-ollama': '/images/courses/ai-testing-deepeval-ragas-ollama.jpg',
  'ai-with-huggingface': '/images/courses/ai-with-huggingface.jpg',
  'build-ai-agent-chatbot-rag-langchain-local-llm': '/images/courses/build-ai-agent-chatbot-rag-langchain-local-llm.jpg',
  'generative-ai-in-software-automation-testing': '/images/courses/generative-ai-in-software-automation-testing.jpg',
  'ai-test-automation-selenium-playwright-llms': '/images/courses/ai-test-automation-selenium-playwright-llms.jpg',
} as const;

export const getAiCourseImage = (courseSlug: string): string | undefined =>
  AI_COURSE_IMAGES[courseSlug as keyof typeof AI_COURSE_IMAGES];
